import { Doughnut } from "vue-chartjs";

let defaultOptions = {
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  tooltips: {
    bodySpacing: 4,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
    xPadding: 10,
    yPadding: 10,
    caretPadding: 10,
  },
  responsive: 1,
  layout: {
    padding: { left: 0, right: 0, top: 15, bottom: 15 },
  },
};

export default {
  name: "doughnut-chart",
  extends: Doughnut,
  props: ["labels", "datasets", "data", "extraOptions", "title"],
  mounted() {
    let chartOptions = Object.assign(defaultOptions, this.extraOptions || {});
    this.renderChart(
      {
        labels: this.labels || [],
        datasets: this.datasets
          ? this.datasets
          : [
              {
                label: this.title || "",
                pointBorderColor: "#FFF",
                pointBorderWidth: 2,
                pointHoverRadius: 4,
                pointHoverBorderWidth: 1,
                pointRadius: 4,
                fill: true,
                borderWidth: 1,
                data: this.data || [],
              },
            ],
      },
      chartOptions
    );
  },
};
